<template>
  <div style="display: contents;">
  <template v-if="!categoryIndex || !categoriesCollapsed">
    <template v-for="(meal,mealIndex) in category.meals">
      <meal
        v-if="!mealIndex || !mealsCollapsed"
        :key="'m' + mealIndex"
        :meal="meal"
        :category="category"
        :packageName="packageName"
        :result="result"
        :hotelName="result.name"
        :showHotelName="showHotelName && !mealIndex"
        :showCategoryName="mealIndex === 0"
        :showCategoriesCollapse="showCollapse && !mealIndex"
        :showMealsCollapse="!mealIndex && (category.meals.length > 1)"
        :showBook="showBook"
        :currency="currency"
        :mealsCollapsed="mealsCollapsed"
        :categoriesCollapsed="categoriesCollapsed"
        :fees="fees"
        :starRating="starRating"
        :selected="selected"
        :displaySelection="displaySelection"
        :displayPackageName="displayPackageName"
        :displayHotelName="displayHotelName"
        :noMeals="category.meals.length"
        :noCategories="noCategories"
        :transport="transport"
        @toggle="$emit('toggle')"
        @info="$emit('info')"
        @priceDetails="$emit('priceDetails', {meal: meal})"
        @mealsToggle="mealsCollapsed = !mealsCollapsed"
        @categoriesToggle="$emit('categoriesToggle')"
        @book="$emit('book',{ mealIndex })"
        ></meal>
    </template>
  </template>
  </div>
</template>

<script>
import meal from './meal_result'

export default {
  props: {
    category: {
      type: Object,
      required: true
    },
    transport: {
      type: String
    },
    starRating: {
      type: Number,
      default: 0
    },
    showCollapse: {
      type: Boolean,
      required: false,
      default: true
    },
    showBook: {
      type: Boolean,
      required: false,
      default: true
    },
    showHotelName: {
      type: Boolean,
      required: true
    },
    packageName: {
      String
    },
    currency: {
      type: String,
      required: true
    },
    fees: {
      type: Object,
      required: false,
      default: () => { return {} }
    },
    categoryIndex: {
      type: Number
    },
    result: {
      type: Object
    },
    selected: {
      type: Boolean
    },
    displaySelection: {
      type: Boolean,
      default: true
    },
    displayPackageName: {
      type: Boolean,
      default: false
    },
    displayHotelName: {
      type: Boolean,
      default: true
    },
    categoriesCollapsed: {
      type: Boolean
    },
    noCategories: {
      type: Number,
      required: true
    },
    allMealsCollapsed: { type: Boolean }
  },
  components: { meal },
  data () {
    return {
      mealsCollapsed: true
    }
  },
  watch: {
    allMealsCollapsed (val) { this.mealsCollapsed = val }
  }
}
</script>
